/**
 * Labstep
 *
 * @module components/Protocol/LinkedList
 * @desc Protocol List
 */

import { ICONS } from 'labstep-web/constants/icons';
import { ElementCard } from 'labstep-web/core/Card/Element';
import LinkButton from 'labstep-web/core/Link/Button';
import { List } from 'labstep-web/core/List';
import { TextPlaceholder } from 'labstep-web/core/Text/Placeholder';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { ProtocolCollection } from 'labstep-web/models/protocol-collection.model';
import type React from 'react';
import styles from './styles.module.scss';
import type { ProtocolCollectionLinkedListProps } from './types';

export const ProtocolCollectionLinkedList: React.FC<
  ProtocolCollectionLinkedListProps
> = ({ params }) => (
  <ReadOnMountHOC
    type="cursor"
    entityName={ProtocolCollection.entityName}
    params={{
      count: 10,
      ...params,
    }}
    children={({ entities, total }) =>
      total > 0 ? (
        <List className={styles.feed} id="protocol-collection-list">
          {entities.map((protocolCollection: ProtocolCollection) => (
            <LinkButton
              key={protocolCollection.id}
              route={{
                to: 'protocol_collection_show',
                params: { id: protocolCollection.id },
              }}
            >
              <ElementCard
                name={protocolCollection.displayName}
                icon={ICONS.protocol_collection.primary}
              />
            </LinkButton>
          ))}
        </List>
      ) : (
        <TextPlaceholder>None</TextPlaceholder>
      )
    }
  />
);
